// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__gsrGO","evityLogo":"Layout_evityLogo__MJnp9"};